import { CSSProperties, useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'

interface ApexChartProps {
  options: ApexOptions
  className?: string
  style?: CSSProperties
}

export function ApexChart(props: ApexChartProps) {
  const chartDivRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const chartDiv = chartDivRef.current
    if (chartDiv == null) return

    const chart = new ApexCharts(chartDiv, props.options)
    chart.render().then()

    return () => chart.destroy()
  }, [props.options])

  return (
    <div className={props.className} style={props.style}>
      <div
        style={{ direction: 'ltr', height: '100%', width: props.options.chart?.width }}
        ref={chartDivRef}
      />
    </div>
  )
}
